import { uri } from '../utils/config';
import { HTTP } from './secure/http';

export const removeImageFromBucket = async (placeId, type, imageId) => {
  if (!placeId || !imageId) {
    console.log('NO PLACE ID');
    return;
  }

  await HTTP.post({
    path: `${uri.api}/place/${placeId}/images/${imageId}/remove`,
    data: { type },
  });
};